export const STRAIGHTTRUCK = {
  label: 'STRAIGHT_TRUCK',
};

export const FLATBED = {
  label: 'FLATBED',
};

export const TRAILER = {
  label: '53_TRAILER',
};

export const VAN = {
  label: 'VAN',
};

export const POWERONLY = {
  label: 'POWER_ONLY',
};

export const PICKUP_TRUCK = {
  label: 'PICKUP_TRUCK',
};

export const CABINET_TRUCK = {
  label: 'CABINET_TRUCK',
};

export const FLATBED_TRUCK = {
  label: 'FLATBED_TRUCK',
};

export const CRANE_TRUCK = {
  label: 'CRANE_TRUCK',
};

export const REEFER_TRUCK = {
  label: 'REEFER_TRUCK',
};

export const FENCE_TRUCK = {
  label: 'FENCE_TRUCK',
};

export const CURTAIN_SIDED_TRUCK = {
  label: 'CURTAIN_SIDED_TRUCK',
};

export const TRAILER_SEMI_TRAILER = {
  label: 'TRAILER_SEMI_TRAILER',
};

export const equipmentTypesUS = [
  { ...STRAIGHTTRUCK },
  { ...FLATBED },
  { ...TRAILER },
  { ...VAN },
  { ...POWERONLY },
];

export const equipmentTypesThai = [
  { ...PICKUP_TRUCK },
  { ...CABINET_TRUCK },
  { ...FLATBED_TRUCK },
  { ...CRANE_TRUCK },
  { ...REEFER_TRUCK },
  { ...FENCE_TRUCK },
  { ...CURTAIN_SIDED_TRUCK },
  { ...TRAILER_SEMI_TRAILER },
];

export const equipmentTypes =
  REGION_CODE === 'AP' ? equipmentTypesThai : equipmentTypesUS;
